import type { FC } from 'react';

import logger from '@eneco/common/log';

const GTMWrapper: FC = () => {
  logger.info('legacy-gtm-deprecated', 'Legacy GTMTag component is deprecated. Please use GTMProvider instead.');
  return null;
};

export default GTMWrapper;
